import { AbstractAsymmetricKeyGenerator } from '../interface';
import { ml_kem1024 } from '@noble/post-quantum/ml-kem.js';
import { compareByteArray, indexOfByteArray } from '../../utility';
import { ml_dsa87 } from '@noble/post-quantum/ml-dsa.js';

export class MLKEM1024KeyGenerator extends AbstractAsymmetricKeyGenerator {
  public static new_key(): { secretKey: Uint8Array; publicKey: Uint8Array } {
    const keys = ml_kem1024.keygen();
    if (indexOfByteArray(keys.publicKey, keys.secretKey) != 1536) {
      throw Error('PK not found in SK');
    }
    return keys;
  }

  public static describe(): string {
    return 'ML-KEM-1024';
  }

  public static regenerate_key_pair(secret_key: Uint8Array): {
    secretKey: Uint8Array;
    publicKey: Uint8Array;
  } {
    return {
      secretKey: secret_key,
      publicKey: secret_key.slice(1536, 3104),
    };
  }
}

export class MLDSA87KeyGenerator extends AbstractAsymmetricKeyGenerator {
  public static new_key(): { secretKey: Uint8Array; publicKey: Uint8Array } {
    const keys = ml_dsa87.keygen();
    if (!compareByteArray(keys.publicKey.slice(0, 32), keys.secretKey.slice(0, 32))) {
      throw new Error('public seed in PK and SK do not match');
    }
    return keys;
  }

  public static describe(): string {
    return 'ML-DSA-87';
  }

  public static regenerate_key_pair(
    secret_key: Uint8Array,
    public_key: Uint8Array
  ): { secretKey: Uint8Array; publicKey: Uint8Array } {
    if (!compareByteArray(public_key.slice(0, 32), secret_key.slice(0, 32))) {
      throw new Error('public seed in PK and SK do not match');
    }
    let plain = crypto.getRandomValues(new Uint8Array(32));
    let signature = ml_dsa87.sign(plain, secret_key);
    if (!ml_dsa87.verify(signature, plain, public_key)) {
      throw new Error('signature did not verify with supplied pk');
    }
    return { secretKey: secret_key, publicKey: public_key };
  }
}
